import React from 'react';
import ReactDOM from 'react-dom/client';

import 'virtual:svg-icons-register';

const isProduction = import.meta.env.VITE_APP_ENV === 'production';

// Disable console output on production
if (typeof window !== 'undefined') {
  if (isProduction) {
    console.log = console.warn = console.debug = () => {};
  }
}

const skin = import.meta.env.VITE_APP_SKIN;

let activeSkin = skin;
if (!activeSkin && typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  if (hostname.includes('lolly')) {
    activeSkin = 'lolly';
  }
}

if (activeSkin && typeof document !== 'undefined') {
  import(`./styles/skins/${activeSkin}.scss`)
    .then(() => {
      const apply = () => document.body.classList.add(`skin-${activeSkin}`);

      if (document.body) apply();
      else window.addEventListener('DOMContentLoaded', apply, { once: true });
    })
    .catch((err) => {
      console.warn(`Failed to load skin "${activeSkin}":`, err);
    });
}

import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);